/**
 * Enumeration for the OptiDrive event exclusion reason types.
 *
 * @readonly
 * @enum {string}
 */
export const OptiDriveEventExclusionReasonType = Object.freeze({
    FALSE_POSITIVE: 'FALSE_POSITIVE',
    DISCUSSED_WITH_DRIVER: 'DISCUSSED_WITH_DRIVER',
    DEVICES_MALFUNCTION: 'DEVICES_MALFUNCTION',
    INCORRECT_DATA_DETECTION: 'INCORRECT_DATA_DETECTION',
    UNEXPECTED_TRAFFIC_EVENT: 'UNEXPECTED_TRAFFIC_EVENT',
    BAD_ROAD_CONDITIONS: 'BAD_ROAD_CONDITIONS',
    DRIVER_EMERGENCY: 'DRIVER_EMERGENCY',
    OTHER: 'OTHER'
})
